import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import clarity from '../utils/clarity';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    clarity.pageView(location.pathname);
  }, [location]);
}; 